import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "@/App.css";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import BOQEditor from "@/pages/BOQEditor";
import RateAnalysisEditor from "@/pages/RateAnalysisEditor";
import Indents from "@/pages/Indents";
import IndentForm from "@/pages/IndentForm";
import Approvals from "@/pages/Approvals";
import SORMaster from "@/pages/SORMaster";
import Thresholds from "@/pages/Thresholds";
import Users from "@/pages/Users";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route
            element={
              <ProtectedRoute>
                <Layout />
              </ProtectedRoute>
            }
          >
            <Route path="/" element={<Dashboard />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/projects/:id" element={<ProjectDetail />} />
            <Route path="/projects/:id/boq" element={<BOQEditor />} />
            <Route
              path="/projects/:id/rate-analysis"
              element={
                <ProtectedRoute roles={["budget_controller", "engineering_head", "admin"]}>
                  <RateAnalysisEditor />
                </ProtectedRoute>
              }
            />
            <Route path="/indents" element={<Indents />} />
            <Route path="/indents/new" element={<IndentForm />} />
            <Route path="/approvals" element={<ProtectedRoute roles={["engineering_head", "chairman"]}><Approvals /></ProtectedRoute>} />
            <Route path="/sor" element={<ProtectedRoute roles={["admin", "engineering_head", "budget_controller"]}><SORMaster /></ProtectedRoute>} />
            <Route path="/thresholds" element={<ProtectedRoute roles={["admin", "engineering_head"]}><Thresholds /></ProtectedRoute>} />
            <Route path="/users" element={<ProtectedRoute roles={["admin"]}><Users /></ProtectedRoute>} />
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster />
    </AuthProvider>
  );
}

export default App;
